import React from 'react';
import { useAppContext } from 'src/components/app-context';
import type { Tab } from 'src/components/sticky-tab-nav/types';
import { TabAnchor } from '../product-tabs/types';
import { ProductNavigationLink } from './styles';

export const useNavigationLinks = (): Tab[] => {
  const { t } = useAppContext();

  return [
    {
      id: TabAnchor.ALL,
      title: (
        <ProductNavigationLink data-test="TabButton" data-test-section="main">
          {t('product', 'tabs.prices')}
        </ProductNavigationLink>
      ),
      scrollToTop: true,
    },
    {
      id: TabAnchor.REVIEWS,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="reviews"
        >
          {t('product', 'tabs.reviews')}
        </ProductNavigationLink>
      ),
    },
    {
      id: TabAnchor.STATISTICS,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="statistics"
        >
          {t('product', 'tabs.price-history')}
        </ProductNavigationLink>
      ),
    },
    {
      id: TabAnchor.PROPERTIES,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="properties"
        >
          {t('product', 'tabs.properties')}
        </ProductNavigationLink>
      ),
    },
  ];
};
